import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CF43DB99-4419-491B-A5E3-2486A36F24DB
 * name numeric-7-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-7-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric7BoxMultipleOutlineIcon = createSvgIcon(<><path d="M13,15L17,7V5H11V7H15L11,15M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z" /></>, 'Numeric7BoxMultipleOutlineIcon');
export default Numeric7BoxMultipleOutlineIcon